<template>
  <div class="mt-8">
    <v-row v-for="(item, index) in data" :key="index" class="ml-0 mt-2">
      <v-col cols="12" class="divider pl-0 mb-2">
        <div class="mb-3 mainS--text">
          <v-chip label class="font-weight-medium mr-4 item-name">{{
            item.name
          }}</v-chip>
          <span class="mr-2">{{ item.type }}</span>
          <span
            :class="{
              'mx-2 item-required': item.required === true,
              'mx-2 item-optional': item.required !== true,
            }"
            >{{
              item.required_text
                ? item.required_text
                : item.required === true
                ? "REQUIRED"
                : "OPTIONAL"
            }}</span
          >
        </div>
        <div v-html="item.description" class="mainS--text"></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "AttributesChildTemplate",
  props: {
    data: Array,
  },
};
</script>

<style lang="scss" scoped>
.divider {
  border-top: 1px solid rgba(136, 151, 162, 0.5) !important;
}
.item-name {
  @extend .gothamRegular;
  color: $clay !important;
  font-size: 16px;
}

.item-type {
  @extend .gothamRegular;
  font-size: 16px;
}

.item-required {
  @extend .gothamRegular;
  color: $danger;
  font-size: 14px;
  font-weight: 600 !important;
}

.item-optional {
  @extend .gothamRegular;
  color: $forestGreen;
  font-size: 14px;
  font-weight: 600 !important;
}
</style>
